import React, { Fragment, useState, useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  tableCellClasses,
  Paper,
  Dialog,
  IconButton,
} from "@mui/material";
import InputField from "components/Input";
import DatePicker from "components/DatePicker";
import { PrimaryButton } from "components/Buttons";
import Colors from "assets/Style/Colors";
import { FontFamily } from "assets";
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import { CancelOutlined } from "@mui/icons-material";
import VendorServices from "services/Vendor";
import EditIcon from '@mui/icons-material/Edit';
// import DropdownMenu from "components/DropDown";

const Row = styled(TableRow)({ border: 0 });
const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "center",
    whiteSpace: "nowrap",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",
    padding: "5px !important",
    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

const useStyles = makeStyles({
  loaderWrap: {
    display: "flex",
    height: 100,
  },
});

const UpdateClaim = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [selectedDate, setSelectedDate] = useState(null);
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);

  const {
    register,
    formState: { errors },
    getValues: getValues1,
  } = useForm();

  const [claimedAmount, setClaimedAmount] = useState(0);
  const [onGws, setOnGws] = useState(0);
  const [closingDate, setClosingDate] = useState(null);
  const [closingRemarks, setClosingRemarks] = useState("");
  const [notess, setNotess] = useState("");
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectNotesDate, setSelectNotesDate] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  const [viewNotes, setViewNotes] = useState(false);

  const handleEditClick = () => {
    setOpenEditModal(true);
  };

  const handleViewClick = () => {
    setViewNotes(true);
  };

  const handleMenuToggle = (menuId, isOpen) => {
    setActiveMenu(isOpen ? menuId : null);
  };

  const [damagesData, setDamagesData] = useState(null);

  const getDamagesData = async () => {
    try {
      const { data } = await VendorServices.getDamagesDetail({ damage_id: id });
      setDamagesData(data?.damage);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!damagesData) return;
    setClaimedAmount(damagesData?.claimed_amount ?? 0);
    setOnGws(
      Math.max(damagesData?.credit_amount - damagesData?.claimed_amount, 0)
    );
    setClosingDate(moment(damagesData?.closing_date).format("YYYY-MM-DD"));
    setClosingRemarks(damagesData?.remarks || "");
    // setNotess(damagesData?.notes || "");
  }, [damagesData]);
  const handleClaimedChange = (val) => {
    let claimed = Number(val || 0);

    if (claimed < 0) {
      claimed = 0;
    }

    const credit = Number(damagesData?.credit_amount ?? 0);
    setClaimedAmount(claimed);
    setOnGws(credit - claimed);
  };

  const handleUpdate = async () => {
    if (claimedAmount <= 0) {
      ErrorToaster("Please add the claimed amount greather than 0.");
      return;
    }
    if (!closingRemarks) {
      ErrorToaster("Please add case closing remarks.");
      return;
    }
    try {
      if (!damagesData?.id) return ErrorToaster("Missing damage record.");

      setLoading(true);

      const credit = Number(damagesData?.credit_amount ?? 0);
      const rawClaimed = (claimedAmount ?? "").toString().trim();
      const claimedParsed =
        rawClaimed === "" || rawClaimed === "-" ? null : Number(rawClaimed);
      const gws_amount =
        claimedParsed === null
          ? credit
          : Number((credit - claimedParsed).toFixed(2));

      const payload = {
        damage_id: damagesData.id,
        booking_id: damagesData.booking_id,
        vendor_id: damagesData.vendor_id,
        claimed_amount: claimedParsed,
        gws_amount: gws_amount,
        claimed_date: closingDate || new Date(),
        credit_amount: damagesData?.credit_amount,
        remarks: (closingRemarks || "").trim() || null,
        notes: notess,
        notes_date: selectNotesDate || new Date(),
        reason: damagesData?.reason,
        vin: damagesData?.booking?.vin,
        lot_number: damagesData?.booking?.lot_number,
        vehicle_make: damagesData?.booking?.veh_make?.name,
        vehicle_model: damagesData?.booking?.veh_model?.name,
        color: damagesData?.booking?.color,
      };

      const { data } = await VendorServices.updateClaim(payload);

      SuccessToaster("Claim updated successfully.");
      navigate("/damages-list");
    } catch (err) {
      ErrorToaster(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveNotes = () => {
    setOpenEditModal(false);
  };

  const handleCloseView = () => {
    setViewNotes(false);
  };

  useEffect(() => {
    getDamagesData();
  }, []);

  return (
    <Fragment>
      <Dialog
        open={openEditModal}
        onClose={handleSaveNotes}
        sx={{
          "& .MuiDialog-paper": {
            width: "70%",
            height: "auto",
            maxHeight: "90%",
            borderRadius: 2,
            py: { xs: 2, md: 4 },
            px: { xs: 3, md: 6 },
          },
        }}
      >
        <IconButton
          onClick={handleSaveNotes}
          sx={{ position: "absolute", right: 13, top: 13 }}
        >
          <CancelOutlined />
        </IconButton>

        <Box component="form">


          <Grid container spacing={2}>
            <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: "bold", justifyContent:"center", alignItems:"center" }}>
              Edit Notes
            </Typography>
            {damagesData?.damageNotes?.map((note, index) => (
              <Box key={index} sx={{ mb: 2, width: "100%", ml: 1.3, mr: 0.3 }}>
                <Grid item xs={12}>
                  <DatePicker
                    label="Date"
                    size="small"
                    value={moment(note?.notes_date).toDate()}
                    disabled={true}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12}>
                  <InputField
                    label="Notes"
                    size="small"
                    multiline
                    rows={3}
                    value={note?.notes || "No notes"}
                    disabled={true}
                    fullWidth
                  />
                </Grid>
              </Box>
            ))}

            <Grid item xs={12}>
              <DatePicker
                label="Date"
                size="small"
                value={selectNotesDate ? moment(selectNotesDate).toDate() : new Date()}
                onChange={(date) => setSelectNotesDate(moment(date).format("YYYY-MM-DD"))}
                disabled={true}
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <InputField
                label="Notes"
                size="small"
                multiline
                rows={3}
                value={notess}
                onChange={(e) => setNotess(e.target.value)}
                placeholder="Enter new notes"
                fullWidth
              />
            </Grid>

            {/* Save Button */}
            <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
              <PrimaryButton
                title="Save"
                // type="submit"
                buttonStyle={{ minWidth: 120 }}
                onClick={handleSaveNotes}
              />
            </Grid>
          </Grid>
        </Box>
        {/* <Box component={"form"}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: "bold" }}>
            Edit Notes
          </Typography>

          
          <DatePicker
            size={"small"}
            label={"Date"}
            value={
              selectNotesDate ? moment(selectNotesDate).toDate() : new Date()
            }
            onChange={(date) =>
              setSelectNotesDate(moment(date).format("YYYY-MM-DD"))
            }
            disabled={true}
          />

          <InputField
            size="small"
            type="text"
            value={notess}
            multiline
            rows={3}
            onInput={(e) => setNotess(e.target.value)}
            placeholder="Notes"
          />
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              mt: 2,
            }}
          >
            <PrimaryButton title="Update" onClick={handleSaveNotes} />
          </Box> 
        </Box>*/}
      </Dialog>

      {/* <Dialog
        open={viewNotes}
        onClose={handleCloseView}
        sx={{
          "& .MuiDialog-paper": {
            width: "70%",
            height: "auto",
            maxHeight: "90%",
            borderRadius: 2,
            py: { xs: 2, md: 4 },
            px: { xs: 3, md: 6 },
          },
        }}
      >
        <IconButton
          onClick={handleCloseView}
          sx={{ position: "absolute", right: 13, top: 13 }}
        >
          <CancelOutlined />
        </IconButton>
        <Box component={"form"}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: "bold" }}>
            View Notes
          </Typography>
          <DatePicker
            size={"small"}
            label={"Date"}
            value={
              selectNotesDate ? moment(selectNotesDate).toDate() : new Date()
            }
            disabled={true}
          />

          <InputField
            size="small"
            type="text"
            value={notess}
            multiline
            rows={3}
            placeholder="Notes"
            disabled
          />
        </Box>
      </Dialog> */}

      <Grid
        container
        spacing={1}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Grid item xs={12} sm={12} md={11}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              mr: 4,
              my: 4,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: Colors.charcoalGrey,
                fontFamily: FontFamily.NunitoRegular,
              }}
            >
              Update Claim
            </Typography>
          </Box>
        </Grid>
        {/* Filters */}
        <Grid item md={11}>
          <Box
            sx={{
              m: "10px 0 10px 0",
            }}
          >
            <Grid
              container
              spacing={2}
              alignItems={"center"}
              component={"form"}
            >
              <Grid item xs={12} sm={2.5}>
                <DatePicker
                  size={"small"}
                  label={"Case Closing Date"}
                  value={
                    closingDate ? moment(closingDate).toDate() : new Date()
                  }
                  onChange={(date) =>
                    setClosingDate(moment(date).format("YYYY-MM-DD"))
                  }
                />
              </Grid>
            </Grid>
          </Box>

          <Box>
            <TableContainer
              component={Paper}
              sx={{
                boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                borderRadius: 2,
                maxHeight: "calc(100vh - 330px)",
                mt: 2,
              }}
              className="table-box"
            >
              <Table stickyHeader sx={{ minWidth: 500 }}>
                <TableHead>
                  <TableRow>
                    <Cell>Vendor</Cell>
                    <Cell>Damage Given Amt</Cell>
                    <Cell sx={{ width: "10%" }}>Claimed Amount</Cell>
                    <Cell>On GWS</Cell>
                    <Cell sx={{ width: "20%" }}>Case Closing Remarks</Cell>
                    <Cell sx={{ width: "20%" }}>Notes</Cell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <Cell>{damagesData?.vendor?.name ?? "-"}</Cell>
                    <Cell>{damagesData?.credit_amount ?? "-"}</Cell>
                    <Cell sx={{ width: "10%" }}>
                      <InputField
                        size="small"
                        type="number"
                        value={claimedAmount}
                        onChange={(e) => handleClaimedChange(e.target.value)}
                        inputProps={{ min: 0, step: "0.01" }}
                      />
                    </Cell>
                    <Cell sx={{ width: "10%" }}>{onGws}</Cell>

                    <Cell sx={{ width: "20%" }}>
                      <InputField
                        size="small"
                        type="text"
                        value={closingRemarks}
                        onInput={(e) => setClosingRemarks(e.target.value)}
                        placeholder="Enter closing remarks"
                      />
                    </Cell>

                    <Cell sx={{ width: "20%" }}>
                      <Box component={"div"} onClick={() => handleEditClick()}>
                        <EditIcon />
                      </Box>
                      {/* <DropdownMenu
                        item={damagesData}
                        // permissions={permissions}
                        isOpen={activeMenu === damagesData?.id}
                        onToggle={(isOpen) =>
                          handleMenuToggle(damagesData?.id, isOpen)
                        }
                        id={damagesData?.id}
                        onClickEditDamageClaimNotes={() => {
                          handleEditClick();
                        }}
                        onClickViewDamageClaimNotes={() => {
                          handleViewClick();
                        }}
                      /> */}
                    </Cell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>

        <Grid item md={11} justifyContent="end">
          <Box
            sx={{
              mt: "28px",
              mb: "28px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <PrimaryButton
              onClick={handleUpdate}
              title="Update"
              loading={loading}
            />
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default UpdateClaim;
